import { all, call } from 'redux-saga/effects';
import PostResetPasswordSaga from './authSaga/PostResetPasswordSaga';
import autoGeneratePasswordSaga from './authSaga/autoGeneratePasswordSaga';
import setPasswordSaga from './authSaga/setPasswordSaga';
import therapistLoginSaga from './authSaga/therapistLoginSaga';
import therapistLogoutSaga from './authSaga/therapistLogoutSaga';
import createEpisodeOfCareSaga from './episodeOfCare/createEpisodeOfCareSaga';
import closeEpisodeOfCareSaga from './episodeOfCare/closeEpisodeOfCareSaga';
import editEpisodeOfCareSaga from './episodeOfCare/editEpisodeOfCareSaga';
import getEpisodeOfCareSaga from './episodeOfCare/getEpisodeOfCareSaga';
import getSingleEpisodeOfCareSaga from './episodeOfCare/getSingleEpisodeOfCareSaga';
import getFacilityDropDownSaga from './facilitySaga/assignFacilitySaga';
import createFacilitiesStaySaga from './facilitySaga/createFacilityStaySaga';
import getAllFacilitiesStaySaga from './facilitySaga/facilityStaySaga';
import updateFacilityDropDownSaga from './facilitySaga/switchFacilitySaga';
import updateFacilitiesStaySaga from './facilitySaga/updateFacilityStaySaga';
import createPtoRequestSaga from './my-availability/createPtoRequest';
import editMyAvailabilitySaga from './my-availability/edit-myAvailabilitySaga';
import getAllPtoRequestSaga from './my-availability/getAllPtoRequestSaga';
import getMyAvailabilitySaga from './my-availability/getMyAvailabilitySaga';
import removePtoRequestSaga from './my-availability/removePtoRequest';
import createPatientSaga from './patient/createPatientSaga';
import deactivatePatientsSaga from './patient/deactivatePatientSaga';
import editPatientSaga from './patient/editPatientSaga';
import getAllPhysicianSaga from './patient/getAllPhysicianSaga';
import getSinglePatientSaga from './patient/getSinglePatientSaga';
import getPatientRecordSaga from './patientSaga/getPatientRecord';
import getAllTherapistDisciplineSaga from './patientSaga/getAllDisciplineTherapistSaga';
import getSingleTherapistDisciplineSaga from './patientSaga/getSingleDisciplineTherapistSaga';
import updateTreatmentTherapistSaga from './patientSaga/putTreatmentTherapistSaga';
import createScreeningSaga from './screeningDetails/createScreeningSaga';
import getDisciplineTypeSaga from './screeningDetails/getDisciplineTypeSaga';
import getScreeningSaga from './screeningDetails/getScreeningSage';
import getScreeningTypeSaga from './screeningDetails/getScreeningTypeSaga';
import getSingleScreeningSaga from './screeningDetails/getSingleScreeningSaga';
import therapistAddTaskSaga from './therapistSaga/therapistAddtaskSaga';
import getAllTherapistListSaga from './therapistSaga/therapistListSaga';
import getTherapistProfileSaga from './therapistSaga/therapistProfileSaga';
import getAllTherapistTaskSaga from './therapistSaga/therapistSchedulingSaga';
import getSkillListSchedulingSaga from './therapistSaga/getSkillsListScheduling';
import getAllTaskTypeSaga from './therapistSaga/therapistTaskSaga';
import getAllSubmittedDocumentForResolver from './documentation/getAllSubmittedDocumentsForResolverSaga';
import {
  createAssessment,
  getAssessment,
  getMDSAssessment,
  getPlanOfCare,
  checkTherapyPlanningPlanMinutesSaga,
  getTherapyPlanning,
  updateAssessment,
  updateTherapyPlanning,
  getDataOfServiceSaga,
  getTherapyPlanningPatientSaga,
  updateTherapyPlanningDischargeDateSaga,
  getIsTherapyPlanningPatient,
} from './therapyPlanning';
import {
  getDailySessionPatientListSaga,
  getPatientInfoSaga,
  updateDailySessionNotesSaga,
  getOtherPatientInfoSaga,
  getDailySessionNotesSaga,
  updateSoapNoteSaga,
} from './dailySessionNotes';
import therapistSchedulingTaskEditSaga from './therapistSaga/therapistSchedulingTaskEditSaga';
import getAllTherapistDiciplineListSaga from './therapistSaga/therapistDisciplineSaga';
import therapistAssignTaskSaga from './therapistSaga/therapistAssignTask';
import therapistMigrateTaskSagaSaga from './therapistSaga/therapistMigratetaskSaga';
import therapistMigratePatientSaga from './therapistSaga/therapistMigratePatientSaga';
import getPayerPlanTypeSaga from './patient/getPayerPlanTypeSaga';
import therapistAssignmentUndoSaga from './therapistSaga/therapistAssignmentUndoSaga';
import getAllFacilitiesSaga from './facilitySaga/getAllFacilitiesSaga';
import getAllTemplatesSaga from './documentation/getAllTemplatesSaga';
import rearrangeTherapistTaskSaga from './therapistSaga/rearrangeTherapistTaskSaga';
import editTaskTimeSaga from './therapistSaga/editTaskTimeSaga';
import callSubmitEventSaga from './documentation/callSubmissionEventSaga';
import getAllSubmittedDocumetSaga from './documentation/getAllSubmittedDocumentsSaga';
import getSubmissionDataSaga from './documentation/getSubmissionData';
import therapistDialogAssignTaskSaga from './therapistSaga/therapistDialogAssignTaskSaga';
import getAllTherapistsByDiscipline from './therapist/getAllTherapistSaga';
import getSignatureTemplateSaga from './documentation/getSignatureTemplateSaga';
import getAllMiscellaneousDocumentsSaga from './documentation/getAllMiscellaneousDocumentsSaga';
import saveMiscellaneousDocumentSaga from './documentation/saveMiscellaneousDocumentSaga';
import dashboardPatientListSaga from './therapist-dashboard-saga/dashboard-patient-list-saga';
import dashboardDocumentListSaga from './therapist-dashboard-saga/dashboard-document-list-saga';
import dashboardTaskOverviewSaga from './therapist-dashboard-saga/dashboard-task-overview-saga';
import dashboardDocumentationOverviewSaga from './therapist-dashboard-saga/dashboard-documentation-overview-saga';
import dashboardTherapySessionOverviewSaga from './therapist-dashboard-saga/dashboard-therapy-overview-saga';
import dashboardTimeCheckInSaga from './therapist-dashboard-saga/dashboard-check-in';
import dashboardTimeCheckOutSaga from './therapist-dashboard-saga/dashboard-checkout';
import getAllSupervisiorsSaga from './documentation/getAllSupervisiorsSaga';
import editSignDocSaga from './documentation/editSignedDocSaga';
import dashboardPatientInfoSaga from './therapist-dashboard-saga/dasboard-patient-info-saga';
import getEpisodeOfCareRequiredDocumentSaga from './episodeOfCare/getRequiredDocumentSaga';
import getNoteTemplateSaga from './dailySessionNotes/getNoteTemplateSaga';
import updateNoteTemplateSaga from './dailySessionNotes/updateNoteSaga';
import submitEsignSaga from './dailySessionNotes/submitEsignSaga';
import getFormIdForScreeningSaga from './screeningDetails/getFormIdForScreeningSaga';
import saveScreeningSubmissionSaga from './screeningDetails/save-screening-submissionSaga';
import getPatientInOrActiveCountsSaga from './patientSaga/getPatientInActiveCount';
import {
  getDepartmentDashboardCountSaga,
  getDepartmentPTOSaga,
  getDepartmentTherapyMinsSaga,
  updateDepartmentPTORequestSaga,
} from './departmentDashboard';
import sendMailToPhysicianSaga from './documentation/sendMailToPhysicianSaga';
import getMonthEndAlertCountSaga from './monthEndAlert/getMonthEndAlertCountSaga';
import getMonthEndAlertThemeCountSaga from './monthEndAlert/getThemeCountSaga';
import getOwnerAlertCountSaga from './monthEndAlert/getOwnerAlertCountSaga';
import getListofMonthEndAlertSaga from './monthEndAlert/getListofMonthEndAlertSaga';
import getAllCodesSaga from './documentation/getCodesSaga';
import autoMatchingTherapistSaga from './therapist/autoMatchingTherapistSaga';
import disableAutoMatchSaga from './therapist/disableAutoMatchSaga';
import defaultTherapistAssignSaga from './therapist/defaultTherapistAssignSaga';
import dashboardPtoUpdatedSaga from './therapist-dashboard-saga/dashboard-pto-updated-saga';
import getCPTCodeByDisciplineSaga from './therapyPlanning/getCPTCodeByDisciplineSaga';
import editAuthorizationSaga from './therapyPlanning/editAuthorizationSaga';
import getDownloadCsvTemplateSaga from './patientSaga/getDownloadCsvTemplateSaga';
import validateCSVTemplateSaga from './patientSaga/validateCSVTemplateSaga';
import uploadCsvTemplateSaga from './patientSaga/uploadCsvTemplateSaga';
import getRecentUploadedHistorySaga from './patientSaga/getRecentUploadedHistorySaga';
import getPatientExportCsvSaga from './patientSaga/getPatientExportCsvSaga';
import getTherapistAvailabilitySaga from './my-availability/getTherapistAvailabilitySaga';
import certifyMonthEndAlertSaga from './monthEndAlert/certifyMonthEndAlertSaga';
import getCertificationStatusSaga from './monthEndAlert/getCertificationStatusSaga';
import dashboardInterventionGroupSaga from './therapist-dashboard-saga/dashboard-intervention-group-saga';
import dashboardGameByInterventionGroupSaga from './therapist-dashboard-saga/dashboard-games-intervention';
import getSignatureAccessSaga from './documentation/getSignatureAccessSaga';
import getAllPatientSaga from './patientSaga/getAllPatientSaga';
import getAuthorizationDetailsSaga from './therapyPlanning/getAuthDetails';
import getAllICDCodesSaga from './documentation/getAllICDSaga';
import pullUuidSaga from './documentation/pulluuidSaga';
import PreGetFacilityDropDownSaga from './facilitySaga/preAssignFacilitySaga';
import preGetTherapistProfileSaga from './therapistSaga/preTherapistProfileSaga';
import getPayComeDetailsSaga from './therapistSaga/gePaycomeDetailsSaga';
import reAssignTherapistSaga from './documentation/reAssignTherapistSaga';
import getAlTherapistListSaga from './documentation/getAllTherapistListSaga';
import getCaseMixGroupSaga from './therapyPlanning/getCaseMixGroupSaga';
import getPrefillUrlSaga from './documentation/getPrefillUrlSaga';
import getLaborHoursSaga from './laborHoursSaga/getLaborHoursSaga';
import getLaborCodes from './laborHoursSaga/getLaborCodesSaga';
import addLaborHoursSaga from './laborHoursSaga/addlaborHoursSaga';
import editLaborHoursSaga from './laborHoursSaga/editLaborHoursSaga';
import getLocationTypeLaborHrSaga from './laborHoursSaga/getLocationTypeLaborHrSaga';
import checkSignatureDailyNotesSaga from './dailySessionNotes/checkSignatureDailyNotes';
import deletePatientTaskSaga from './therapistSaga/deletePatientTaskSaga';
import deleteLaborHoursSaga from './laborHoursSaga/deleteLaborHoursSaga';
import getAllDisciplineTherapistsSaga from './therapist/getAllDisciplineTherapist';
import getStartCareOfDateSaga from './documentation/getStartOfCareDateSaga';
import monthlyCloseoutAlertSaga from './monthlyCloseOutAlret/monthlyCloseoutAlertSaga';
import getUnlockTherapistSaga from './getUnlockTherapistSaga/getUnlockTherapistSaga';
import getLockDailySessionNoteSaga from './getUnlockTherapistSaga/getLockDailySessionNoteSaga';
import updateUnlockTherapistSaga from './getUnlockTherapistSaga/updateUnlockTherapistSaga';
import uploadSignatureFileSaga from './monthlyCloseOutAlret/uploadSignatureFileSaga';
import getMultipleMdsAssessmentSaga from './therapyPlanning/getMultipleMDSAssessmentSaga';
import addsignerMdsformSaga from './mdsCommunication/addSignerMdsFormSaga';
import getAllMdsFormSaga from './mdsCommunication/getAllMdsFormSaga';
import getMdsFormIdSaga from './mdsCommunication/getMdsFormIdSaga';
import signMdsFormSaga from './mdsCommunication/signMdsFormSaga';
import getTherapistsByRoleSaga from './mdsCommunication/getTherapistsByRoleSaga';
import getMdsFormByIdSaga from './mdsCommunication/getMdsFormByIdSaga';
import deleteRequiredDocSaga from './documentation/deleteRequiredDocSaga';
import getMdsTypeSaga from './mdsCommunication/getMdsTypeSaga';
import getPrepareProgressNoteSaga from './documentation/getPrepareProgressNoteSaga';
import getAutoClockOutSaga from './therapist-dashboard-saga/getauto-clock-out-call-saga';
import getPaginatedPatientSaga from './patientSaga/getPaginatedPatientsSaga';
import getAllCompetedDocSaga from './documentation/getAllCompetedDoc';
import dashboardDocumentListCsvSaga from './therapist-dashboard-saga/dashboardDocumentCSVListSaga';
import getCPTCodesDescriptionSaga from './copyTextBank/getCPTCodeDescriptionSaga';
import validateMdsAssessmentSaga from './therapyPlanning/validateMdsAssesmentCsvSaga';
import uploadMdsCsvTemplateSaga from './therapyPlanning/uploadMdsCsvTemplateSaga';
import getPatientListRecordSaga from './patientSaga/getAllPatientListSaga';
import syncAlertFromSignatureSaga from './therapist-dashboard-saga/sync-alerts-after-signature';
import getMdsReformIdSaga from './mdsCommunication/getMdsReformIdSaga';
import getContractCountSaga from './contract/getContractCountSaga';
import getPhysicianDocumentsSaga from './physiciansaga/getAllPhysicianDocumentsSaga';
import updateDocumentStatusesSaga from './physiciansaga/updateDocumentStatusesSaga';
import getFacilitySaga from './physiciansaga/getAllFacilitiesSaga';
import getAllPatientByEnterpriseSaga from './physiciansaga/getAllPatientByEnterprise';
import checkPhysicianSignatureSaga from './physiciansaga/checkPhysicianSaga';
import checkAssignTaskPTOSaga from './departmentDashboard/checkAssignTaskPTOSaga';
import getPhysicianCompletedDocumentsSaga from './physiciansaga/completedPhysicianDocumentSaga';
import getTherapyPlanningPatientSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningPatient_2_0';
import getTherapyPlanningDataSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningDataSaga_2_0';
import getTherapyPlanningSummarySaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningSummarySaga_2_0';
import editSingleCellTherapyPlanningSaga from './therapyPlanning/therapyPlanning2.0/editSingleCellTherapyPlanningSaga';
import updateUncoveredDayTherapyPlanningSaga from './therapyPlanning/therapyPlanning2.0/updateUncoveredDayTP_2.0';
import getTherapyPlanningDischargeDateSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningDischargeDate_2.0';
import copyPasteTherapyPlanningSaga_2_0 from './therapyPlanning/therapyPlanning2.0/copyPasteTherapyPlanningSaga_2_0';
import applyTheTherapyTemplatesSaga from './therapyPlanning/therapyPlanning2.0/applyTheTherapyTemplatesSaga';
import getAllTherapyPlanningTemplatesSaga from './therapyPlanning/therapyPlanning2.0/getAllTherapyPlanningTemplates';
import applySelectedTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/applySelectedTherapyTemplateSaga';
import createNewTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/createNewTherapyTemplateSaga';
import deleteTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/deleteTherapyTemplateSaga';
import editTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/editTherapyTemplateSaga';
import getSchedulingTaskNoteSaga from './therapist-scheduling-saga/get-scheduling-task-note-saga';
import createSchedularTaskNoteSaga from './therapist-scheduling-saga/create-note-task-scheduling-saga';
import deleteTaskNoteSchedularSaga from './therapist-scheduling-saga/delete-task-note-schedular-saga';
import therapistPatientUnAssign from './therapistSaga/therapistPatientUnAssignSaga';
import deleteMdsAssessmentByDateSaga from './therapyPlanning/therapyPlanning2.0/deleteMdsAssesmentByDateSaga';
import deleteSingleMdsAssessmentSaga from './therapyPlanning/therapyPlanning2.0/deleteSingleMdsAssessmentSaga';
import maintainTherapistFilterSaga from './therapistSaga/maintainTherapistFilterSaga';
import getAllMaintainedTherapistSaga from './therapistSaga/getAllMaintainedTherapistsSaga';
import getSchedularAnnouncementsSaga from './therapist-scheduling-saga/get-schedular-announcements-saga';
import createAnnouncementSaga from './therapist-scheduling-saga/create-schedular-announce-saga';
import updateAnnouncementSaga from './therapist-scheduling-saga/update-schedular-announce-saga';
import deleteAnnouncementSaga from './therapist-scheduling-saga/delete-schedular-announce-saga';
import getMdsAssessmentRangeSaga from './therapyPlanning/therapyPlanning2.0/getMdsAssessmentRange';
import getSingleMdsAssessmentSaga from './therapyPlanning/therapyPlanning2.0/getSingleMdsAssessmentSaga';
import getTherapyPlanning7dayLookBackSaga from './therapyPlanning/therapyPlanning2.0/getTherapyPlanning7dayLookBackSaga';
import therapistDailyUpdatesSaga from './therapist-dashboard-saga/dashboard-therapist-daily-update-saga';
import isDischargeDocumentAllowSaga from './documentation/isDischargeDocumentAllowSaga';
import newDocumentSignSaga from './documentation/newDocumentSignSaga';
import undoDocumentSignSaga from './documentation/undoDocumentSignSaga';
import checkPendingDocsAlertSaga from './documentation/checkPendingDocsAlert';
import setCommonDurationSaga from './therapist-scheduling-saga/set-common-duration-saga';

function* rootSaga() {
  yield all([
    call(updateTherapyPlanningDischargeDateSaga),
    call(getSingleTherapistDisciplineSaga),
    call(checkTherapyPlanningPlanMinutesSaga),
    call(getDataOfServiceSaga),
    call(getIsTherapyPlanningPatient),
    call(defaultTherapistAssignSaga),
    call(autoMatchingTherapistSaga),
    call(disableAutoMatchSaga),
    call(updateTreatmentTherapistSaga),
    call(getAllTherapistDisciplineSaga),
    call(deletePatientTaskSaga),
    call(dashboardDocumentationOverviewSaga),
    call(dashboardTherapySessionOverviewSaga),
    call(getLaborCodes),
    call(getAllDisciplineTherapistsSaga),
    call(getSkillListSchedulingSaga),
    call(updateDailySessionNotesSaga),
    call(createAssessment),
    call(getCaseMixGroupSaga),
    call(getDepartmentPTOSaga),
    call(getDepartmentTherapyMinsSaga),
    call(updateDepartmentPTORequestSaga),
    call(getDepartmentDashboardCountSaga),
    call(getDailySessionNotesSaga),
    call(getDailySessionPatientListSaga),
    call(getPatientInfoSaga),
    call(getTherapyPlanning),
    call(updateTherapyPlanning),
    call(getAssessment),
    call(closeEpisodeOfCareSaga),
    call(getMDSAssessment),
    call(getPlanOfCare),
    call(updateAssessment),
    call(therapistLoginSaga),
    call(getTherapyPlanningPatientSaga),
    call(createPatientSaga),
    call(editPatientSaga),
    call(therapistLogoutSaga),
    call(createEpisodeOfCareSaga),
    call(editEpisodeOfCareSaga),
    call(getSingleEpisodeOfCareSaga),
    call(getEpisodeOfCareSaga),
    call(getScreeningSaga),
    call(createScreeningSaga),
    call(setPasswordSaga),
    call(getTherapistProfileSaga),
    call(getSinglePatientSaga),
    call(getFacilityDropDownSaga),
    call(updateSoapNoteSaga),
    call(updateFacilityDropDownSaga),
    call(getPatientRecordSaga),
    call(getAllFacilitiesStaySaga),
    call(updateFacilitiesStaySaga),
    call(getDisciplineTypeSaga),
    call(getScreeningTypeSaga),
    call(getSingleScreeningSaga),
    call(deactivatePatientsSaga),
    call(getAllPhysicianSaga),
    call(createFacilitiesStaySaga),
    call(autoGeneratePasswordSaga),
    call(PostResetPasswordSaga),
    call(getMyAvailabilitySaga),
    call(getAllPtoRequestSaga),
    call(createPtoRequestSaga),
    call(removePtoRequestSaga),
    call(getOtherPatientInfoSaga),
    call(editMyAvailabilitySaga),
    call(getAllTherapistTaskSaga),
    call(getAllTaskTypeSaga),
    call(getAllTherapistListSaga),
    call(getAllTherapistDiciplineListSaga),
    call(therapistAssignTaskSaga),
    call(therapistMigrateTaskSagaSaga),
    call(therapistMigratePatientSaga),
    call(therapistAddTaskSaga),
    call(therapistSchedulingTaskEditSaga),
    call(getPayerPlanTypeSaga),
    call(therapistAssignmentUndoSaga),
    call(getAllFacilitiesSaga),
    call(getAllTemplatesSaga),
    call(rearrangeTherapistTaskSaga),
    call(therapistDialogAssignTaskSaga),
    call(editTaskTimeSaga),
    call(callSubmitEventSaga),
    call(getAllSubmittedDocumetSaga),
    call(getSubmissionDataSaga),
    call(getAllTherapistsByDiscipline),
    call(getSignatureTemplateSaga),
    call(getAllMiscellaneousDocumentsSaga),
    call(saveMiscellaneousDocumentSaga),
    call(dashboardPatientListSaga),
    call(dashboardDocumentListSaga),
    call(dashboardTaskOverviewSaga),
    call(dashboardTimeCheckInSaga),
    call(dashboardTimeCheckOutSaga),
    call(getAllSupervisiorsSaga),
    call(editSignDocSaga),
    call(dashboardPatientInfoSaga),
    call(getEpisodeOfCareRequiredDocumentSaga),
    call(getNoteTemplateSaga),
    call(updateNoteTemplateSaga),
    call(submitEsignSaga),
    call(getFormIdForScreeningSaga),
    call(saveScreeningSubmissionSaga),
    call(getPatientInOrActiveCountsSaga),
    call(sendMailToPhysicianSaga),
    call(getMonthEndAlertCountSaga),
    call(getMonthEndAlertThemeCountSaga),
    call(getOwnerAlertCountSaga),
    call(getListofMonthEndAlertSaga),
    call(getAllCodesSaga),
    call(dashboardPtoUpdatedSaga),
    call(getCPTCodeByDisciplineSaga),
    call(editAuthorizationSaga),
    call(getDownloadCsvTemplateSaga),
    call(validateCSVTemplateSaga),
    call(uploadCsvTemplateSaga),
    call(getRecentUploadedHistorySaga),
    call(getPatientExportCsvSaga),
    call(getTherapistAvailabilitySaga),
    call(certifyMonthEndAlertSaga),
    call(getCertificationStatusSaga),
    call(dashboardInterventionGroupSaga),
    call(dashboardGameByInterventionGroupSaga),
    call(getSignatureAccessSaga),
    call(getAllPatientSaga),
    call(getAuthorizationDetailsSaga),
    call(getAllICDCodesSaga),
    call(pullUuidSaga),
    call(PreGetFacilityDropDownSaga),
    call(preGetTherapistProfileSaga),
    call(getPayComeDetailsSaga),
    call(reAssignTherapistSaga),
    call(getAlTherapistListSaga),
    call(getPrefillUrlSaga),
    call(getLaborHoursSaga),
    call(addLaborHoursSaga),
    call(editLaborHoursSaga),
    call(getLocationTypeLaborHrSaga),
    call(checkSignatureDailyNotesSaga),
    call(deleteLaborHoursSaga),
    call(getStartCareOfDateSaga),
    call(getContractCountSaga),
    call(monthlyCloseoutAlertSaga),
    call(getUnlockTherapistSaga),
    call(getLockDailySessionNoteSaga),
    call(updateUnlockTherapistSaga),
    call(uploadSignatureFileSaga),
    call(getMultipleMdsAssessmentSaga),
    call(addsignerMdsformSaga),
    call(getAllMdsFormSaga),
    call(getMdsFormIdSaga),
    call(signMdsFormSaga),
    call(getTherapistsByRoleSaga),
    call(getMdsFormByIdSaga),
    call(deleteRequiredDocSaga),
    call(getMdsTypeSaga),
    call(getPrepareProgressNoteSaga),
    call(getAutoClockOutSaga),
    call(getPaginatedPatientSaga),
    call(dashboardDocumentListCsvSaga),
    call(getCPTCodesDescriptionSaga),
    call(validateMdsAssessmentSaga),
    call(uploadMdsCsvTemplateSaga),
    call(getPatientListRecordSaga),
    call(getAllCompetedDocSaga),
    call(syncAlertFromSignatureSaga),
    call(getMdsReformIdSaga),
    call(getPhysicianDocumentsSaga),
    call(updateDocumentStatusesSaga),
    call(getFacilitySaga),
    call(getAllPatientByEnterpriseSaga),
    call(checkPhysicianSignatureSaga),
    call(checkAssignTaskPTOSaga),
    call(getPhysicianCompletedDocumentsSaga),
    call(getTherapyPlanningPatientSaga_2_0),
    call(getTherapyPlanningDataSaga_2_0),
    call(getTherapyPlanningSummarySaga_2_0),
    call(editSingleCellTherapyPlanningSaga),
    call(updateUncoveredDayTherapyPlanningSaga),
    call(getTherapyPlanningDischargeDateSaga_2_0),
    call(copyPasteTherapyPlanningSaga_2_0),
    call(getAllSubmittedDocumentForResolver),
    call(applyTheTherapyTemplatesSaga),
    call(getAllTherapyPlanningTemplatesSaga),
    call(applySelectedTherapyTemplateSaga),
    call(createNewTherapyTemplateSaga),
    call(deleteTherapyTemplateSaga),
    call(editTherapyTemplateSaga),
    call(getSchedulingTaskNoteSaga),
    call(createSchedularTaskNoteSaga),
    call(deleteTaskNoteSchedularSaga),
    call(therapistPatientUnAssign),
    call(getMdsAssessmentRangeSaga),
    call(getSingleMdsAssessmentSaga),
    call(deleteMdsAssessmentByDateSaga),
    call(deleteSingleMdsAssessmentSaga),
    call(maintainTherapistFilterSaga),
    call(getAllMaintainedTherapistSaga),
    call(getSchedularAnnouncementsSaga),
    call(createAnnouncementSaga),
    call(updateAnnouncementSaga),
    call(deleteAnnouncementSaga),
    call(getTherapyPlanning7dayLookBackSaga),
    call(therapistDailyUpdatesSaga),
    call(isDischargeDocumentAllowSaga),
    call(newDocumentSignSaga),
    call(undoDocumentSignSaga),
    call(checkPendingDocsAlertSaga),
    call(setCommonDurationSaga),
  ]);
}

export default rootSaga;
